import { axios } from '@/utils/axios'
import { orderStatusMap, payStatusMap, payTypeMap } from '@/dicts/order'

// 航班预订校验（临期）
export async function chooseValidate (params) {
  try {
    const data = await axios({
      // url: '/api/flight/check/near/flight',
      url: '/api/flight/V3/check/near/flight',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升旅客航段信息
export async function paxSegmentNew (params) {
  try {
    const data = await axios({
      // url: '/api/change/order/query/paxsegment/info',
      url: '/api/change/order/V3/query/paxsegment/info',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升查询航班
export async function queryChangeNew (params) {
  try {
    const data = await axios({
      url: '/api/change/order/query/flight',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升查询航班 - v2
export async function queryChangeNewV2 (params) {
  try {
    const data = await axios({
      // url: '/api/change/order/V2/query/flight',
      url: '/api/change/order/V3/query/flight',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升下单
export async function createNew (params) {
  try {
    const data = await axios({
      url: '/api/change/order/create/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升下单 - v2
export async function createNewV2 (params) {
  try {
    const data = await axios({
      // url: '/api/change/order/V2/create/flight',
      url: '/api/change/order/V3/create/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升单详情
export async function detailNew (params) {
  try {
    const data = await axios({
      // url: '/api/change/order/queryChangeDetail',
      url: '/api/change/order/V3/queryChangeDetail',
      method: 'post',
      data: params
    })

    if (data) {
      data.detail.statusCn = orderStatusMap[data?.detail?.status]

      data.detail.payments?.forEach(pay => {
        pay.payStatusCn = payStatusMap[pay.payStatus]
        pay.payTypeCn = payTypeMap[pay.payType]
      })
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升单取消
export async function cancelNew (params) {
  try {
    return await axios({
      // url: '/api/change/order/cancelChange',
      url: '/api/change/order/V3/cancelChange',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 新版改升补出票
export async function confirmOrderNew (params) {
  try {
    return await axios({
      url: '/api/change/order/confirm/flight',
      // url: '/api/change/order/V3/confirm/flight',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升新航段补出票
export async function newSeg (params) {
  try {
    return await axios({
      url: '/api/flight/newseg/confirm/change/flight',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升航班时刻更新
export async function refresh (params) {
  try {
    return await axios({
      url: '/api/flight/refresh/flight/time',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 旧订单接口 - 支持代理人

// 改升旅客航段信息
export async function paxSegmentV1 (params) {
  try {
    const data = await axios({
      url: '/api/flight/query/change/paxsegment/info',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升查询航班
export async function queryChangeV1 (params) {
  try {
    const data = await axios({
      url: '/api/flight/query/change/flight',
      method: 'post',
      data: params
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升下单
export async function createV1 (params) {
  try {
    const data = await axios({
      url: '/api/flight/create/change/flight',
      method: 'post',
      data: params,
      timeout: 300000
    })

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升单详情
export async function detailV1 (params) {
  try {
    const data = await axios({
      url: '/api/flight/detail/change/flight',
      method: 'post',
      data: params
    })

    if (data) {
      data.detail.statusCn = orderStatusMap[data?.detail?.status]
    }

    return data
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升单取消
export async function cancelV1 (params) {
  try {
    return await axios({
      url: '/api/flight/cancel/change/flight',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 改升补出票
export async function confirmOrderV1 (params) {
  try {
    return await axios({
      url: '/api/flight/confirm/change/flight',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
